import React, { useCallback, useState } from 'react';
import { Form, Button, Select } from 'antd';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { ParticipantUserSelectForm } from '@fragments/Form';
import { formErrorHandler } from '@common/utils/form';
import { FormaEmbed } from '@containers/Form';

const FormItem = Form.Item;
const Option = Select.Option;

const ParticipantForm = (props) => {
	const {
		module,
		data,
		onSubmit,
		match,
		product,
		onCancel,
		organization,
	} = props;
	const intl = useIntl();

	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);

	const handleFinish = useCallback(
		(values) => {
			setLoading(true);

			if (organization?._id) {
				values['organization'] = organization?._id;
			}

			if (module) {
				values['module'] = module.code;
				values[module.code] = match?.params[`moduleId`];
			}

			if (product) {
				values['product'] = product;
			}

			onSubmit(values)
				.then(() => setLoading(false))
				.catch((err) => {
					setLoading(false);
					formErrorHandler(err, values, form);
				});
		},
		[onSubmit, organization]
	);

	return (
		<Form
			layout="vertical"
			form={form}
			name="position-form"
			onFinish={handleFinish}
			initialValues={{ ...data, user: data?.user?._id }}>
			<ParticipantUserSelectForm
				data={data}
				code={module.code}
				id={match?.params[`moduleId`]}
				disabled={data}
			/>

			<FormItem
				label={`Status`}
				name="status"
				rules={[
					{
						required: true,
						message: intl.formatMessage({
							id: 'form.validation.status.required',
							defaultMessage: 'Please input status',
						}),
					},
				]}>
				<Select
					placeholder="Please select status"
					style={{ width: '100%' }}
					optionFilterProp="title"
					filterOption={(input, option) =>
						option.props.children
							.toLowerCase()
							.indexOf(input.toLowerCase()) >= 0
					}>
					<Option value={'invited'} title={'Invited'}>
						Invited
					</Option>
					<Option value={'rsvp'} title={'RSVP'}>
						Accepted
					</Option>
					<Option value={'requested'} title={'Requested'}>
						Declined
					</Option>
				</Select>
			</FormItem>
			<Form.List name="extra" wrapperCol={{ span: 24 }}>
				{() => (
					<>
						<FormaEmbed
							form={props[module.code]?.forms?.participant}
						/>
					</>
				)}
			</Form.List>
			<FormItem className="mt-5">
				<Button type="secondary" onClick={() => onCancel && onCancel()}>
					{intl.formatMessage({
						id: 'common.cancel',
						defaultMessage: 'Cancel',
					})}
				</Button>
				&nbsp;&nbsp;
				<Button
					loading={loading}
					type="primary"
					htmlType="submit"
					className="login-form-button">
					{intl.formatMessage({
						id: 'common.submit',
						defaultMessage: 'Submit',
					})}
				</Button>
			</FormItem>
		</Form>
	);
};

const mapStateToProps = ({ auth, event, organization }) => {
	return {
		auth,
		event,
		organization,
	};
};

export default connect(mapStateToProps, {})(ParticipantForm);
